export default "__VITE_ASSET__DInH$EWp__"